export default __webpack_public_path__ + "static/font-81e72216434d6c224cf204fc28436747.woff2";